import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { User } from 'lucide-react';

const avatarStyle = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  objectFit: 'cover',
  border: '1px solid rgba(176, 133, 226, 0.3)',
};

const fallbackStyle = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid rgba(255,255,255,0.12)',
  background: 'rgba(15, 23, 42, 0.95)',
};

const PlayerSelect = ({
  value,
  options = [],
  onChange,
  playerImages = {},
}) => {
  const rootRef = useRef(null);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        rootRef.current &&
        !rootRef.current.contains(event.target) &&
        (!menuRef.current || !menuRef.current.contains(event.target))
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    if (!open || !buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    setMenuStyle({
      position: 'fixed',
      top: rect.bottom + 6,
      left: rect.left,
      minWidth: rect.width,
    });
  }, [open]);

  const renderAvatar = (name) => (
    playerImages[name] ? (
      <img src={playerImages[name]} alt={name} style={avatarStyle} />
    ) : (
      <span style={fallbackStyle}>
        <User size={16} color="#9ca3af" />
      </span>
    )
  );

  return (
    <div ref={rootRef} style={{ position: 'relative' }}>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="player-roles-player-btn"
      >
        {renderAvatar(value)}
        <span style={{ fontSize: '13px', textAlign: 'left' }}>{value || 'Select player'}</span>
        <span className="chevron">▼</span>
      </button>

      {open && ReactDOM.createPortal(
        <div
          ref={menuRef}
          style={{
            ...menuStyle,
            zIndex: 1400,
            background: '#081120',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: '10px',
            boxShadow: '0 18px 40px rgba(0,0,0,0.4)',
            padding: '6px',
            maxHeight: '260px',
            overflowY: 'auto',
          }}
        >
          {options.map((player) => (
            <button
              key={player}
              type="button"
              onClick={() => {
                onChange(player);
                setOpen(false);
              }}
              style={{
                width: '100%',
                border: 'none',
                borderRadius: '8px',
                background: player === value ? 'rgba(176,133,226,0.16)' : 'transparent',
                color: '#e2e8f0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '8px 10px',
                cursor: 'pointer',
              }}
            >
              {renderAvatar(player)}
              <span style={{ fontSize: '13px' }}>{player}</span>
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default PlayerSelect;
